import { useBaseApi } from "./BaseApiHook";

export interface AttackForgeProject {
  ID: string;
  Name: string;
  Code: string;
  LastUpdate: Date;
}

export interface AttackForgeVuln {
  id: number;
  projectId: string;
  vulnID: string;
  created: Date;
  title: string;
  severity: string; //TODO:: The EDR has this as an enum
  status: string;
  assetName: string;
  lastUpdate: Date;
}

export const useAttackForgeApi = () => {
  const { request } = useBaseApi();

  return {
    GetIssues: async (productID: string): Promise<Array<AttackForgeVuln>> => request("GET", "/af/vulns/" + productID),
  }
}
